import React, { Component } from 'react'
import { apiAwardsProgressOverview } from 'helpers/decorators/api'
import { meta, permissions, tableCommon } from 'helpers/decorators'
import { connect } from 'react-redux'
import { awardsProgressOverview as awardsProgressOverviewApi } from '../../../redux/modules/api'
import { AwardsProgressOverviewTable } from '../../../components/sections/awards'
import FilterAwardsProgressOverview from '../../filters/FilterAwardsProgressOverview/FilterAwardsProgressOverview'

@meta({
  title: 'Awards Progress Overview',
  intlKey: 'pageTitle.awards_progress_overview'
})
@permissions()
@apiAwardsProgressOverview({
  list: true,
  useCommonLimit: true
})
@tableCommon()
@connect(
    () => ({
    }),
    { setFilter: awardsProgressOverviewApi.setAwardsProgressOverviewFilter }
)
class AwardsProgressOverview extends Component {
  render() {
    return (
      <div>
        <FilterAwardsProgressOverview />
        <AwardsProgressOverviewTable {...this.props} />
      </div>
    )
  }
}

export default AwardsProgressOverview
